import { Exception } from './exception';

export class EmptyValueException extends Exception {}
